
import { observer } from 'mobx-react-lite';
import { useParams } from 'react-router-dom';

import Stack from '@mui/joy/Stack';

import useChatRoom from 'hooks/useChatRoom';

// import useTeam from 'hooks/useTeam';


import LoadingSection from './LoadingSection';
import MessagesPane from './MessagesPane';

const ChatRoom = observer(() => {

    const { uuid } = useParams<{uuid: string}>();
    const { getChatRoom } = useChatRoom();

    // we load it in ChatRoomContainer
    const room = uuid ? getChatRoom(uuid) : null;

    if(!room) {
        return <LoadingSection />;
    }
    return (
        <Stack>
        <MessagesPane bubbleSize="small" associated_type="chat_room" associated_uuid={room.uuid} />
        </Stack>
    );
});
export default ChatRoom;
